"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSigner = createSigner;
const bech32_1 = require("bech32");
const ed25519_1 = require("@mysten/sui/keypairs/ed25519");
// Function to decode Bech32 private key
function decodeBech32PrivateKey(bech32Key) {
    const decoded = bech32_1.bech32.decode(bech32Key);
    const decodedBytes = Buffer.from(bech32_1.bech32.fromWords(decoded.words));
    // Strip leading byte if the key is 33 bytes
    if (decodedBytes.length === 33) {
        return decodedBytes.subarray(1);
    }
    if (decodedBytes.length !== 32) {
        throw new Error(`Invalid secretKey size. Expected 32 bytes, got ${decodedBytes.length}.`);
    }
    return decodedBytes;
}
// Function to create signer
function createSigner(bech32Key) {
    const privateKeyBytes = decodeBech32PrivateKey(bech32Key);
    const keypair = ed25519_1.Ed25519Keypair.fromSecretKey(privateKeyBytes);
    return keypair;
}
//# sourceMappingURL=utils.js.map